import z from 'zod'
import { decimalSchema } from '../../utils/schema'

// MEXC Spot Trade History の1件分の取引データスキーマ
const tradeHistorySchema = z.object({
  /** 取引ペアシンボル (例: BTCUSDT) */
  symbol: z.string(),
  /** deal id (文字列) */
  id: z.string(),
  /** order id (文字列) */
  orderId: z.string(),
  /** order list id (整数) */
  orderListId: z.number().int(),
  /** 価格 */
  price: decimalSchema,
  /** 約定数量 (base) */
  qty: decimalSchema,
  /** 約定数量 (quote) */
  quoteQty: decimalSchema,
  /** 手数料数量 */
  commission: decimalSchema,
  /** 手数料アセット */
  commissionAsset: z.string(),
  /** 約定時刻 (UNIXミリ秒) */
  time: z.number().int(),
  /** 自分が買い手か */
  isBuyer: z.boolean(),
  /** メイカーか */
  isMaker: z.boolean(),
  /** ベストマッチか */
  isBestMatch: z.boolean(),
  /** 自己取引か */
  isSelfTrade: z.boolean(),
  /** クライアント注文ID (null 許容) */
  clientOrderId: z.string().nullable(),
})

// レスポンスは取引オブジェクト配列
export const responseSchema = z.array(tradeHistorySchema)
